import { Button, Card, CardContent, Grid, Snackbar, TextField, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SaveIcon from '@material-ui/icons/Save';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import MaskedInput from 'react-text-mask';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { getUser, setUserMobile } from 'src/utils/Common';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitButton: {
    marginTop: theme.spacing(1),
    width: '100%'
  }
}));

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      guide={false}
      showMask
    />
  );
}
function Kayit() {
  const SessionUser = getUser();

  let TelefonGelen = SessionUser.MobileNumber;
  if (TelefonGelen === "4440888") {
    TelefonGelen = "";
  }

  const [teknisyenTelefon, setteknisyenTelefon] = useState(TelefonGelen);
  const [LoadingControl, setLoadingControl] = useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [uyari, setUyari] = React.useState(false);
  // eslint-disable-next-line
  const [DogrulamaKodu, setDogrulamaKodu] = React.useState();


  const [responseMessage, setresponseMessage] = useState({ ErrorCode: "0", ErrorDescription: "İşleminiz başarı ile gerçekleştirildi." });
  const classes = useStyles();
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleChangeTeknisyenTelefon = (event) => {
    setteknisyenTelefon(event.target.value);
  };

  const TelefonKaydet = () => {
    if (teknisyenTelefon === undefined) {
      setresponseMessage({ ErrorCode: 0, ErrorDescription: "Telefon numarasını kontrol ediniz!..." });
      setUyari(true);
      setUyariTip("error");
      return;
    }

    if (teknisyenTelefon.length !== 14) {
      setresponseMessage({ ErrorCode: 0, ErrorDescription: "Telefon numarasını kontrol ediniz!..." });
      setUyari(true);
      setUyariTip("error");
    }

    const formattedPhone = teknisyenTelefon.replace('(', '').replace(')', '').replace('-', '').replace(' ', '');

    if (!formattedPhone){
      setLoadingControl(false);
      return;
    }

    axios.get(`/GetArcloudCustomMethodByParams/${parseInt(SessionUser.ServiceShopCode)}/${formattedPhone}/${SessionUser.UserId}`)
      .then(() => {
      }).catch(error => {
              logger.error("Hata detayı:", error.message);
      });

   
    setLoadingControl(true);
    const data = [{
      TechnicianId: parseInt(SessionUser.TechnicianId),
      ServiceShopId: parseInt(SessionUser.ServiceShopId),
      Phone: teknisyenTelefon,
      Code: DogrulamaKodu,
      Type: 1,
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    axios.post('/SetArtemisTechnicianPhone', data, config).then(response => {
      let ResponseData = response.data;
      setresponseMessage(ResponseData);
      if (ResponseData.ErrorCode === "0") {
        setUyariTip("success");
        setUserMobile(teknisyenTelefon.replace('(','').replace(')','').replace('-','').replace(' ',''));
      } else {
        setUyariTip("error");
      }
      setUyari(true);
      setLoadingControl(false);
    }).catch(error => {
      setLoadingControl(false);
      setresponseMessage({ ErrorCode: 0, ErrorDescription: "Error" });
      setUyari(true);
      setUyariTip("error");
            logger.error("Hata detayı:", error.message);
    });
  };

  return (
    <Card>
      <Snackbar open={uyari} onClose={uyariKapat} autoHideDuration={4000}>
        <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
      </Snackbar>
      <CardContent>
        {
          LoadingControl ?
            <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />
            : <div></div>
        }
        <Typography variant="subtitle1" gutterBottom>
          <div className={classes.fields}>
            <TextField
              label="Teknisyen Telefon Numarası"
              name="TeknisyenTelefon"
              value={teknisyenTelefon}
              placeholder="(5xx) xxx-xxxx"
              InputProps={{
                inputComponent: TextMaskCustom,
              }}
              onChange={handleChangeTeknisyenTelefon}
              fullWidth
              variant="outlined"
            />
          </div>
        </Typography>
        <div className={classes.fields}>
          <Grid container spacing={1}>
            <Grid item xs={12} align="right">
              <Button
                variant="contained"
                color="secondary"
                onClick={TelefonKaydet}
                className={classes.submitButton}
                endIcon={<SaveIcon>Kaydet</SaveIcon>}
              >
                Kaydet
            </Button>
            </Grid>
          </Grid>
        </div>
      </CardContent>
    </Card>
  );
}
Kayit.propTypes = {
  className: PropTypes.string
};

export default Kayit;